import { CheckCircleFilled, ExclamationCircleFilled } from '@ant-design/icons';
import { t } from '@lingui/macro';
import React from 'react';
import BukkuTooltip from '../../Tooltip';

export default function MyInvoisReady({record}) {
    return record.is_myinvois_ready ?
        <BukkuTooltip title={t`MyInvois Ready`}>
            <CheckCircleFilled style={{ color: '#52c41a' }} />
        </BukkuTooltip> :
        <BukkuTooltip title={t`Not MyInvois Ready`}>
            <ExclamationCircleFilled style={{ color: '#faad14' }} />
        </BukkuTooltip>;
}
